
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"12.248","cy":"11.758","r":"6.017","transform":"rotate(45 12.248 11.758)","fill":"currentColor"}}),_c('path',{attrs:{"d":"M2.25 12c0 2.804.288 4.448.507 5.294a1.5 1.5 0 00.9 1.027C6.798 19.533 12 19.5 12 19.5s5.201.033 8.344-1.18a1.501 1.501 0 00.903-1.026c.219-.844.507-2.49.507-5.294 0-2.804-.288-4.448-.507-5.294a1.501 1.501 0 00-.903-1.031C17.2 4.467 12 4.5 12 4.5s-5.201-.033-8.344 1.18a1.5 1.5 0 00-.903 1.03c-.215.84-.503 2.486-.503 5.29z","stroke":"#4A4A4A","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M2.25 12c0 2.804.288 4.448.507 5.294a1.5 1.5 0 00.9 1.027C6.798 19.533 12 19.5 12 19.5s5.201.033 8.344-1.18a1.501 1.501 0 00.903-1.026c.219-.844.507-2.49.507-5.294 0-2.804-.288-4.448-.507-5.294a1.501 1.501 0 00-.903-1.031C17.2 4.467 12 4.5 12 4.5s-5.201-.033-8.344 1.18a1.5 1.5 0 00-.903 1.03c-.215.84-.503 2.486-.503 5.29z","stroke":"#4A4A4A","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M15 12l-4.5-3v6l4.5-3z","stroke":"#4A4A4A","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M15 12l-4.5-3v6l4.5-3z","stroke":"#4A4A4A","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    